<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '7' }}</span></div>
        <h4>Сalculation options</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div>
            <div class="body-1 mb-8">Select your preferred variance calculation approach</div>
            <div class="radio-group separate-blocks flex-column">
                <label>
                    <input type="radio" name="analysis" [(ngModel)]="baseLineType" [value]="VarianceFormulaBaselineType.Canonical">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1">Canonical</span>
                            <span class="body-2 mb-16">This approach follows a specific evaluation sequence for the formula components, and minimizes variance residuals. Please define your desired
                                sequence by rearranging the formula components below.</span>
                            <ng-container *ngIf="baseLineType == VarianceFormulaBaselineType.Canonical">
                                <div cdkDropList class="tile-container" (cdkDropListDropped)="drop($event)">
                                    <div cdkDrag *ngFor="let formCompVar of canonical; let i = index" class="tile-row">
                                        <div cdkDragHandle class="btn btn-secondary">
                                            <span class="material-icons-outlined">drag_indicator</span><span>{{ formCompVar.formCompName }}</span>
                                        </div>
                                        <div class="body-2">
                                            <span *ngFor="let item of formCompVar.newFormulaPart" [ngClass]="{ 'text-900': item.type === FormulaItemType.NewFormComp }">{{item.text}}</span>
                                            <span class="text-900"> − </span><br>
                                            <span *ngFor="let item of formCompVar.oldFormulaPart" [ngClass]="{ 'text-900': item.type === FormulaItemType.NewFormComp }">{{item.text}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="radio-legend">
                                    <a class="body-2">{{oldControlValue}}</a>
                                    <a class="active body-2">{{newControlValue}}</a>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </label>
                <label>
                    <input type="radio" name="analysis" [(ngModel)]="baseLineType" [value]="VarianceFormulaBaselineType.Old">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1">Use {{oldControlValue}} as a baseline</span>
                            <span class="body-2">Evaluate the drivers using a sequence-independent approach, with {{oldControlValue}} as the baseline.</span>
                            <ng-container *ngIf="baseLineType == VarianceFormulaBaselineType.Old">
                                <div class="tile-container">
                                    <div *ngFor="let formCompVar of oldBaseLine; let i = index" class="tile-row">
                                        <div class="btn btn-secondary">
                                            <span>{{ formCompVar.formCompName }}</span>
                                        </div>
                                        <div class="body-2">
                                            <span *ngFor="let item of formCompVar.newFormulaPart" [ngClass]="{ 'text-900': item.type === FormulaItemType.NewFormComp }">{{item.text}}</span>
                                            <span class="text-900">-</span>
                                            <span *ngFor="let item of formCompVar.oldFormulaPart" [ngClass]="{ 'text-900': item.type === FormulaItemType.NewFormComp }">{{item.text}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="radio-legend">
                                    <a class="body-2">{{oldControlValue}}</a>
                                    <a class="active body-2">{{newControlValue}}</a>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </label>
                <label>
                    <input type="radio" name="analysis" [(ngModel)]="baseLineType" [value]="VarianceFormulaBaselineType.New">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1">Use {{newControlValue}} as a baseline</span>
                            <span class="body-2">Evaluate the drivers using a sequence-independent approach, with {{newControlValue}} as the baseline.</span>
                            <ng-container *ngIf="baseLineType == VarianceFormulaBaselineType.New">
                                <div class="tile-container">
                                    <div *ngFor="let formCompVar of newBaseLine; let i = index" class="tile-row">
                                        <div class="btn btn-secondary">
                                            <span>{{ formCompVar.formCompName }}</span>
                                        </div>
                                        <div class="body-2">
                                            <span *ngFor="let item of formCompVar.newFormulaPart" [ngClass]="{ 'text-900': item.type === FormulaItemType.NewFormComp }">{{item.text}}</span>
                                            <span class="text-900">-</span>
                                            <span *ngFor="let item of formCompVar.oldFormulaPart" [ngClass]="{ 'text-900': item.type === FormulaItemType.NewFormComp }">{{item.text}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="radio-legend">
                                    <a class="body-2">{{oldControlValue}}</a>
                                    <a class="active body-2">{{newControlValue}}</a>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="info-block">
            <span class="body-1">Preferred variance</span>
            <span *ngIf="baseLineType == VarianceFormulaBaselineType.Canonical" class="body-1 text-900">Canonical</span>
            <span *ngIf="baseLineType == VarianceFormulaBaselineType.Old" class="body-1 text-900">{{oldControlValue}} as a baseline</span>
            <span *ngIf="baseLineType == VarianceFormulaBaselineType.New" class="body-1 text-900">{{newControlValue}} as a baseline</span>
        </div>
        <div>
            <button (click)="editClick()" [ngClass]="{'loading-small':loading}" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
